import { render, staticRenderFns } from "./UpdatePictogramFlow.vue?vue&type=template&id=6c00e471"
import script from "./UpdatePictogramFlow.vue?vue&type=script&lang=js"
export * from "./UpdatePictogramFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports